import React from "react";
import { CreditCard, RotateCcw, Truck } from "lucide-react";
import { useI18n } from "../../lib/i18n";
import { pickLocale } from "../../lib/format";

/* Line icons only, and only three of them: the set is fixed so an editor cannot
   introduce a pictogram that does not belong to the drawing style. */
const ICONS = { payment: CreditCard, delivery: Truck, returns: RotateCcw };

/**
 * The service strip, in the reference design.
 *
 * Three centred columns separated by vertical hairlines on a desktop and by
 * horizontal ones once they stack — the icon above the label rather than beside
 * it, and no card around either.
 */
export default function TrustBenefits({ block }) {
  const { locale } = useI18n();
  const items = (block?.items || []).filter((item) => pickLocale(item?.title, locale));
  if (!items.length) return null;

  return (
    <section className="bg-white border-t border-charcoal/10 py-12 md:py-16" data-testid="home-trust">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-12 md:divide-x divide-charcoal/10">
          {items.slice(0, 3).map((item, index) => {
            const Icon = ICONS[item.icon] || CreditCard;
            return (
              <div
                key={`${item.icon}-${index}`}
                className={`flex flex-col items-center text-center px-4 space-y-4 ${
                  index > 0 ? "pt-6 md:pt-0 border-t border-charcoal/10 md:border-t-0" : ""
                }`}
              >
                <Icon className="w-6 h-6 text-charcoal stroke-[1]" aria-hidden="true" />
                <span className="font-semibold text-[10px] tracking-[0.1em] uppercase">
                  {pickLocale(item.title, locale)}
                </span>
                {pickLocale(item.text, locale) && (
                  <span className="text-charcoal/60 text-xs font-medium">
                    {pickLocale(item.text, locale)}
                  </span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
